import { useState } from 'react';
import styles from './LeavesPage.module.css';

import { useDispatch } from 'react-redux';

import DynamicTable from './../../../components/DynamicTable/DynamicTable';
import PaginationTable from './../../../components/PaginationTable/PaginationTable';
import IconAndName from './../../../components/IconAndName/IconAndName';
import { IoIosAddCircleOutline } from 'react-icons/io';
import { FaRegEdit } from 'react-icons/fa';
import { openModal } from './../../../redux/slices/modalSlice';

const LeavesPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const dispatch = useDispatch();

  const data = [
    {
      _id: 's1',
      leaveType: 'Medical',
      allocated: '01  ',
      approved: '03',
      pending: '04',
      denied: '04',
      leavesLeft: '00',
    },
    {
      _id: 's2',
      leaveType: 'Medical',
      allocated: '01  ',
      approved: '03',
      pending: '04',
      denied: '04',
      leavesLeft: '00',
    },
    {
      _id: 's3',
      leaveType: 'Medical',
      allocated: '01  ',
      approved: '03',
      pending: '04',
      denied: '04',
      leavesLeft: '00',
    },
    {
      _id: 's4',
      leaveType: 'Medical',
      allocated: '01  ',
      approved: '03',
      pending: '04',
      denied: '04',
      leavesLeft: '00',
    },
    {
      _id: 's5',
      leaveType: 'Medical',
      allocated: '01  ',
      approved: '03',
      pending: '04',
      denied: '04',
      leavesLeft: '00',
    },
    {
      _id: 's6',
      leaveType: 'Medical',
      allocated: '01  ',
      approved: '03',
      pending: '04',
      denied: '04',
      leavesLeft: '00',
    },
    {
      _id: 's7',
      leaveType: 'Medical',
      allocated: '01  ',
      approved: '03',
      pending: '04',
      denied: '04',
      leavesLeft: '00',
    },
  ];

  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        leaveType: item.leaveType || '-',
        allocated: item.allocated || '-',
        approved: item.approved || '-',
        pending: item.pending || '-',
        denied: item.denied || '-',
        leavesLeft: item.leavesLeft || '-',
      };
    });
  };
  const columnData = getColumnData(data);

  const headings = [
    { title: 'Leave Type', accessor: 'leaveType' },
    { title: 'Allocated', accessor: 'allocated' },
    { title: 'Approved', accessor: 'approved' },
    { title: 'Pending', accessor: 'pending' },
    { title: 'Denied', accessor: 'denied' },
    { title: 'Leaves Left', accessor: 'leavesLeft' },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.totaltable}>
        <div className={styles.controlsBar}>
          <div className={styles.topWrapper}>
            <div
              className={styles.editWrapper}
              onClick={() => {
                dispatch(openModal({ type: 'chooseRange' }));
              }}
            >
              <FaRegEdit size={18} />
              <span>This Month</span>
            </div>

            <IconAndName
              icon={<IoIosAddCircleOutline />}
              title="New Leave"
              bgColor="Primary_Color"
              onClick={() => {
                dispatch(openModal({ type: 'leaveDetails' }));
              }}
            />
          </div>
        </div>

        <div className={styles.tableBox}>
          <DynamicTable
            headings={headings}
            columnData={columnData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
          <PaginationTable
            data={columnData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
};

export default LeavesPage;
